import * as React from 'react';
import {YearMonth} from "./utils/YearMonthRangePicker";
import furoApi from "../api/FuroApi";
import {
  ApplicationContextConsumer,
  bindLoadingHandler,
  LoadingOverlayHandler,
  withLoadingOverlay
} from "../app/ApplicationContext";
import {ErrorResponse, Item} from "../api/dtos/dtos";
import {ErrorAlert} from "../common/ErrorAlert";
import './utils/Statistics.css';
import {CostStatistics, StatisticsRequest, TotalItemCostStatistics, UsageStatistics} from "../api/dtos/statistics";
import ItemStatisticsPanel from "./ItemStatisticsPanel";

interface Props {
  item: Item;
  reload: boolean;
}

interface State {
  request?: StatisticsRequest;
  totalCostStats?: TotalItemCostStatistics;
  usageStats?: UsageStatistics;
  costStats?: CostStatistics;
  error?: ErrorResponse;
}

class ItemStatisticsPage extends React.Component<Props, State> {

  public readonly loadingHandler?: LoadingOverlayHandler;

  public state: State = {};

  public componentDidMount(): void {
    this.loadTotalCostStatistics();
  }

  public componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>) {
    if (this.props.reload && prevProps.reload !== this.props.reload) {
      this.reload();
    }
  }

  public render(): React.ReactNode {
    const {totalCostStats, usageStats, costStats, error} = this.state;
    const isInfiniteStock = this.props.item.infiniteStock === true;
    return (
      <>
        <ApplicationContextConsumer>
          {({loadingHandler}) => bindLoadingHandler(loadingHandler, this)}
        </ApplicationContextConsumer>
        <ItemStatisticsPanel
          infiniteStock={isInfiniteStock}
          onQueryParamsChange={this.onQueryParamsChange}
          totalCostStats={totalCostStats}
          usageStats={usageStats}
          costStats={costStats}
        />
        <ErrorAlert style={{marginTop: 16}} error={error}/>
      </>
    );
  }

  private onQueryParamsChange = (start: YearMonth, end: YearMonth) => {
    const {item} = this.props;
    const request: StatisticsRequest = {
      startYear: start.year,
      startMonth: start.month,
      endYear: end.year,
      endMonth: end.month
    };
    this.setState({request});
    this.loadStatisticsInRange(item.id!, request);
  };

  private reload = () => {
    this.loadTotalCostStatistics();
    const {request} = this.state;
    if (request) {
      this.loadStatisticsInRange(this.props.item.id!, request);
    }
  };

  private loadStatisticsInRange = (itemId: number, request: StatisticsRequest) => {
    const promise = furoApi.statistics.getItemStatistics(itemId, request)
      .then(response => this.setState({
        costStats: response.costStatistics,
        usageStats: response.usageStatistics,
        error: undefined,
      }))
      .catch(this.onApiError);
    withLoadingOverlay(promise, this.loadingHandler);
  };

  private loadTotalCostStatistics = () => {
    const {item} = this.props;
    const promise = furoApi.statistics.getTotalItemCostStatistics(item.id!)
      .then(response => this.setState({
        totalCostStats: response,
        error: undefined
      }))
      .catch(this.onApiError);
    withLoadingOverlay(promise, this.loadingHandler);
  };

  private onApiError = (error: ErrorResponse) => {
    this.setState({error});
  };
}

export default ItemStatisticsPage;


// WEBPACK FOOTER //
// ./src/statistics/ItemStatisticsPage.tsx